const PLATFORM_FAVICON_ID = "midpoint-platform-favicon";
const PLATFORM_APPLE_ICON_ID = "midpoint-platform-apple-icon";

let defaultDocumentTitle =
  typeof document !== "undefined" ? document.title : "Midpoint Map";

export const PLATFORM_SITE_NAME = "Midpoint Map";
export const PLATFORM_FAVICON = "/icons/icon-512.svg";

export function captureDefaultDocumentTitle() {
  if (typeof document !== "undefined" && document.title) {
    defaultDocumentTitle = document.title;
  }
  return defaultDocumentTitle;
}

export function getDefaultDocumentTitle() {
  return defaultDocumentTitle;
}

export function upsertMeta(attr, name, content) {
  if (!content || typeof document === "undefined") return;
  const selector =
    attr === "property" ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    if (attr === "property") {
      element.setAttribute("property", name);
    } else {
      element.setAttribute("name", name);
    }
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export function upsertLink(id, rel, href, extra = {}) {
  if (!href || typeof document === "undefined") return null;
  let element = document.getElementById(id);
  if (!element) {
    element = document.createElement("link");
    element.id = id;
    element.rel = rel;
    document.head.appendChild(element);
  }
  element.href = href;
  Object.entries(extra).forEach(([key, value]) => {
    if (value != null) {
      element.setAttribute(key, value);
    }
  });
  return element;
}

export function removeLink(id) {
  document.getElementById(id)?.remove();
}

export function applyDocumentTitle(title) {
  if (!title || typeof document === "undefined") return;
  document.title = title;
}

export function applyFavicon(href, { id = PLATFORM_FAVICON_ID, rel = "icon" } = {}) {
  upsertLink(id, rel, href, { type: href?.endsWith(".svg") ? "image/svg+xml" : undefined });
}

export function applyAppleTouchIcon(href, { id = PLATFORM_APPLE_ICON_ID } = {}) {
  upsertLink(id, "apple-touch-icon", href);
}

export function applyPlatformBrandHead() {
  applyFavicon(PLATFORM_FAVICON);
  applyAppleTouchIcon(PLATFORM_FAVICON);
}

export function restorePlatformBrandHead(previousTitle) {
  if (previousTitle) {
    applyDocumentTitle(previousTitle);
  }
  applyPlatformBrandHead();
}
